import { Component, inject, Input } from '@angular/core';
import { FormArray, FormBuilder, FormControl } from '@angular/forms';
import { DynamicDialogRef } from 'primeng/dynamicdialog';

import { LessonComponentBuilders, LessonComponentConfiguration, LessonComponentEnum, LessonCompSettings } from './lessons.clases';
import { nanoid } from 'nanoid';

// Create a type that maps the interface to FormControls
export type LessonCompSettingsForm = {
  [K in keyof Required<LessonCompSettings>]: FormControl<LessonCompSettings[K]>;
};

export interface ComponentBuildData {
  str: string;
  obj: LessonComponentConfiguration;
}

@Component({
  selector: 'app-component-builder',
  template: '<div>no template</div>',
})
export abstract class ComponentBuilder {
  @Input() inputs: Record<string, any>;
  @Input() id: string;

  // Added abstract
  abstract componentName: string; // Added abstract property

  protected formBuilder = inject(FormBuilder);
  protected ref = inject(DynamicDialogRef);

  // Sobreescribir si es necesario
  // public formGroup = this.formBuilder.group<LessonCompSettings>({});

  public formGroup = this.formBuilder.group({
    response: new FormControl<string | null>(null),
    responses: new FormControl<string | null>(null),
    options: new FormArray([]),
    text: new FormControl<string | null>(null),
    hint: new FormControl<string | null>(null),
    explanation: new FormControl<string | null>(null),
  });

  // Every component knows its type by comparing agains LessonComponentBuilders
  get questionType(): LessonComponentEnum {
    const self = this;

    const name = Object.keys(LessonComponentBuilders).find((componentName: any) => {
      const componentClass = LessonComponentBuilders[componentName];
      if (self instanceof componentClass) {
        return componentName;
      }
    });

    return <LessonComponentEnum>name;
  }

  protected getCode(): LessonComponentConfiguration {
    const data = this.formGroup.value;
    // Deleting null values
    Object.keys(data).forEach((key) => {
      if (data[key] === null) {
        delete data[key];
      }
    });
    const code: LessonComponentConfiguration = { component: this.componentName, inputs: { ...data } };
    return code;
  }

  public showCode() {
    const code = this.getCode();
    const stringCode = `~${JSON.stringify(code)}~`;
    alert(stringCode);
  }

  public getComponentData(): ComponentBuildData {
    const code = this.getCode();

    if (this.id) {
      code.id = this.id;
    } else {
      const id = nanoid().replace(/-/g, '_');
      code.id = id;
    }
    return { str: `~${JSON.stringify(code)}~`, obj: code };
  }

  // TODO: for now copyToClipboard is the that that closes modal and return data.
  public async copyToClipboard() {
    const data = this.getComponentData();
    await navigator.clipboard.writeText(data.str);
    this.ref.close(data);
  }
}
